/* eslint-disable max-len */
import React, { FC } from "react";

type IProps = {
  width?: number;
  height?: number;
};

const SvgComponent: FC<IProps> = ({ width = 23, height = 24 }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 24 25" fill="none">
    <path d="M18 11.4009H14C13.7348 11.4009 13.4804 11.5062 13.2929 11.6938C13.1054 11.8813 13 12.1357 13 12.4009V17.4009C13 17.6661 13.1054 17.9205 13.2929 18.108C13.4804 18.2955 13.7348 18.4009 14 18.4009H18M6 7.40088V20.4009C6 20.9313 6.21071 21.44 6.58579 21.8151C6.96086 22.1902 7.46957 22.4009 8 22.4009H16C16.5304 22.4009 17.0391 22.1902 17.4142 21.8151C17.7893 21.44 18 20.9313 18 20.4009V7.40088M5 2.40088H19C19.5523 2.40088 20 2.84859 20 3.40088V6.40088C20 6.95316 19.5523 7.40088 19 7.40088H5C4.44772 7.40088 4 6.95316 4 6.40088V3.40088C4 2.84859 4.44772 2.40088 5 2.40088Z" stroke="#262626" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

export default SvgComponent;
